import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loading" }

import HollowDotsSpinner from './HollowDotsSpinner.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingSpinner',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HollowDotsSpinner, {
      class: "loading__spinner",
      "animation-duration": 2000,
      "dot-size": 20,
      "dots-num": 3,
      color: '#ffd000'
    })
  ]))
}
}

})